import React from 'react';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import Input from 'src/shared/components/input/Input';
import QuestionButtonHelp from 'src/shared/components/question-button-help/QuestionButtonHelp';
import useHabitatInsightsUpload from 'src/app/habitat-insights/views/habitat-insights-details/components/habitat-insights-upload/hooks/useHabitatInsightsUpload';
import styles from './CustomerContacts.module.scss';

export const CustomerContacts = () => {
    const { formState, onFormChange } = useHabitatInsightsUpload();
    const { leadRole } = formState;
    return (
        <div className='mt-[30px]'>
            <div className='text-[18px] text-black border-b border-black mb-[36px]'>Project contact</div>

            <div className={styles.projectContact}>
                <div className={styles.userIcon}>
                    <PersonOutlineOutlinedIcon />
                </div>
                <div className={styles.contactDetails}>
                    <div className={styles.contactDetailsName}>{formState.leadName || 'Not set'}</div>
                    <div>{formState.leadEmail || 'Not set'}</div>
                </div>
                <div className={styles.role}>
                    <div className={styles.roleTitle}>
                        Job title <QuestionButtonHelp type='api' slug='project-definition-role' />
                    </div>
                    <Input
                        placeholder='Type job title'
                        value={leadRole}
                        onChange={event => onFormChange({ leadRole: event.target.value })}
                    />
                </div>
            </div>
        </div>
    );
};
export default CustomerContacts;
